/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { useQuery } from '@apollo/client';

import { ROUTES } from '@xing-com/crate-jobs-paths';
import { MasterDirectoryPopularSkillsDocument } from '@xing-com/crate-master-directory-graphql';

type EntryByLetterParams = {
  jobRole: string;
};

export const useGetPopularSkills = ({
  jobRole,
}: EntryByLetterParams): {
  loading: boolean;
  collection: {
    displayName: string;
    url: string;
    moreUrl: string;
  }[];
} => {
  const { loading, data } = useQuery(MasterDirectoryPopularSkillsDocument, {
    variables: {
      jobRole,
    },
  });

  const collection = (data?.jobsLinkBoxJobRolesRelatedSkills || []).map(
    (skill) => ({
      displayName: skill?.name || '',
      url: `/jobs/skill/${skill?.seoName}`,
      moreUrl: `${ROUTES.jobsDirectory}/skill/${skill?.seoName}`,
    })
  );

  return { loading, collection };
};
